(function ($) {
  "use strict";

  /* --------------------------------------------------------------------------
   *  GSAP plugin registration (once)
   * -------------------------------------------------------------------------- */
  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }

  /* --------------------------------------------------------------------------
   *  Slick sliders
   * -------------------------------------------------------------------------- */

  function initVideoSlider() {
    if (typeof $.fn.slick !== "function") return;

    var $videoSlider = $(".video_slider");
    if (!$videoSlider.length) return;

    $videoSlider.each(function () {
      $(this).slick({
        slidesToShow: 3.5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    });

    // External arrows
    $(".arrow-flex .cat-prev-slide").on("click", function () {
      $videoSlider.slick("slickPrev");
    });

    $(".arrow-flex .cat-next-slide").on("click", function () {
      $videoSlider.slick("slickNext");
    });
  }

  function initCaseSlider() {
    if (typeof $.fn.slick !== "function") return;

    var $caseSlide = $(".case_slide");
    if (!$caseSlide.length) return;

    $caseSlide.each(function () {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true
      });
    });
  }

  function initWatchSlides() {
    if (typeof $.fn.slick !== "function") return;

    var $watchSlide = $(".watch_slide");
    if ($watchSlide.length) {
      $watchSlide.each(function () {
        $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          vertical: true
        });
      });
    }

    var $watchSlide2 = $(".watch_slide2");
    if ($watchSlide2.length) {
      $watchSlide2.each(function () {
        $(this).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          centerMode: true,
          vertical: true,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      });
    }
  }

  /* --------------------------------------------------------------------------
   *  Sticky cards (GSAP ScrollTrigger)
   * -------------------------------------------------------------------------- */

  function initStickyCards() {
    if (!window.gsap || !window.ScrollTrigger) return;

    var cardsWrappers = gsap.utils.toArray(".card-wrapper");
    var cards = gsap.utils.toArray(".card");
    var endTrigger = document.querySelector(".service-section-wrap") || null;

    if (!cardsWrappers.length || !cards.length) return;

    cardsWrappers.forEach(function (wrapper, i) {
      var card = cards[i];
      if (!card) return;

      var endScale = 0.5;
      var endBlur = 30;
      var endYOffset = -30;
      var endRotateX = -12;

      gsap.fromTo(
        card,
        {
          scale: 1,
          y: 0,
          filter: "blur(0px)",
          rotationX: 0
        },
        {
          scale: endScale,
          y: endYOffset,
          filter: "blur(" + endBlur + "px)",
          rotationX: endRotateX,
          transformOrigin: "top center",
          ease: "none",
          scrollTrigger: {
            trigger: wrapper,
            start: "top " + (60 + 10 * i),
            end: "bottom 50",
            endTrigger: endTrigger || wrapper,
            scrub: true,
            pin: wrapper,
            pinSpacing: false,
            id: i + 1
          }
        }
      );
    });
  }

  /* --------------------------------------------------------------------------
   *  Scroll controlled video in .free_wrist (GSAP + rAF smoothing)
   * -------------------------------------------------------------------------- */

  function initScrollVideoSection() {
    if (!window.gsap || !window.ScrollTrigger) return;

    // Respect prefers-reduced-motion and avoid heavy scroll video on small screens
    // if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // if (window.matchMedia("(max-width: 767px)").matches) return;

    var root = document.querySelector(".free_wrist");
    if (!root) return;

    function pickVideo() {
      return window.matchMedia("(max-width: 767px)").matches
        ? root.querySelector(".video-background.mobile-show")
        : root.querySelector(".video-background.desk-show");
    }

    var video = pickVideo();
    if (!video) return;

    // Do not autoplay by attribute, let scroll drive the time
    video.autoplay = false;
    video.removeAttribute("autoplay");
    video.muted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    try {
      video.pause();
    } catch (e) {}

    var src = video.currentSrc || video.src;
    var animDiv = root.querySelector(".animations");

    // Protect time when switching between desktop / mobile video on resize
    window.addEventListener("resize", function () {
      var v2 = pickVideo();
      if (v2 && v2 !== video) {
        try {
          video.pause();
        } catch (e) {}
        video = v2;
        src = video.currentSrc || video.src;
      }
    });

    // Helper: once
    function once(el, event, fn, opts) {
      var onceFn = function (e) {
        el.removeEventListener(event, onceFn);
        fn.apply(el, arguments);
      };
      el.addEventListener(event, onceFn, opts);
      return onceFn;
    }

    // iOS autoplay policies
    once(document.documentElement, "touchstart", function () {
      video.play();
      video.pause();
    });

    // Main scroll timeline
    var tl;

    once(video, "loadedmetadata", function () {
      var dur = Math.max(0.001, video.duration || 1);
      var endPad = 0.08; // about 80 ms safety

      tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: "top top",
          end: "+=3000",
          scrub: 0.2,
          pin: true,
          anticipatePin: 1,
          onUpdate: function (self) {
            var t = Math.min(dur - 0.001, self.progress * dur);
            video._target = t;

            // start rAF loop once
            if (!video._rAF) {
              video._curr = video.currentTime || 0;
              var smooth = 0.35;

              var tick = function () {
                var target = video._target || 0;
                video._curr += (target - video._curr) * smooth;

                if (video._curr > dur - 0.001) video._curr = dur - 0.001;
                if (video._curr < 0.001) video._curr = 0.001;

                if (Math.abs(video.currentTime - video._curr) > 0.0005) {
                  video.currentTime = video._curr;
                }

                video._rAF = window.requestAnimationFrame(tick);
              };

              video._rAF = window.requestAnimationFrame(tick);
            }

            if (animDiv) {
              animDiv.style.display = t >= dur - endPad ? "block" : "none";
            }
          },
          onLeave: function () {
            if (video._rAF) {
              window.cancelAnimationFrame(video._rAF);
              video._rAF = 0;
            }
            video._target = dur - 0.001;
            video.currentTime = dur - 0.001;
            video.pause();
          },
          onLeaveBack: function () {
            if (video._rAF) {
              window.cancelAnimationFrame(video._rAF);
              video._rAF = 0;
            }
            video._target = 0.001;
            video.currentTime = 0.001;
            video.pause();
          }
        }
      });

      // Dummy tween just to give ScrollTrigger a duration to scrub against
      tl.to({}, { duration: dur, ease: "none" });
    });

    // Optional Safari memory fix
    setTimeout(function () {
      if (!window.fetch || !src || String(src).indexOf("blob:") === 0) return;
      fetch(src)
        .then(function (r) {
          if (!r.ok) throw new Error("fetch failed");
          return r.blob();
        })
        .then(function (blob) {
          var blobURL = URL.createObjectURL(blob);
          var t = video.currentTime || 0;
          once(document.documentElement, "touchstart", function () {
            video.play();
            video.pause();
          });
          video.src = blobURL;
          video.currentTime = t + 0.01;
        })
        .catch(function () {});
    }, 1000);
  }

  /* --------------------------------------------------------------------------
   *  Banner slider + progress bars (requestAnimationFrame)
   * -------------------------------------------------------------------------- */

  function initBannerSliderProgress() {
    if (typeof $.fn.slick !== "function") return;

    var $banner = $(".banner-slider");
    if (!$banner.length) return;

    var slideCount = $banner.find(".item").length;
    if (!slideCount) return;

    var $progressContainer = $(".progressBarContainer");
    if (!$progressContainer.length) return;

    // Build progress bar items in one shot
    var html = "";
    for (var i = 0; i < slideCount; i++) {
      html +=
        '<div class="item"><span data-slick-index="' +
        i +
        '" class="progressBar"></span></div>';
    }
    $progressContainer.html(html);

    // Init slider
    $banner.slick({
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    // Create inProgress inner divs
    $(".progressBarContainer .progressBar").each(function (index) {
      $(this).html("<div class='inProgress inProgress" + index + "'></div>");
    });

    var percentTime = 0;
    var tick = null;
    var progressBarIndex = 0;
    var indexCount = slideCount - 1;
    var time = 0.1; // keep your original factor
    var lastTime = null;

    function resetProgressbar() {
      $(".inProgress").css({ width: "0%" });
      if (tick) {
        window.cancelAnimationFrame(tick);
        tick = null;
      }
      lastTime = null;
    }

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      tick = window.requestAnimationFrame(rafInterval);
    }

    function rafInterval(timestamp) {
      if (!lastTime) {
        lastTime = timestamp;
      }
      var delta = timestamp - lastTime;
      lastTime = timestamp;

      // If visible slide changed, sync index
      var $visible = $banner
        .find('.slick-track div[aria-hidden="false"]')
        .first();
      var visibleIndex = $visible.data("slickIndex");
      if (
        typeof visibleIndex !== "undefined" &&
        visibleIndex !== progressBarIndex
      ) {
        progressBarIndex = visibleIndex;
        startProgressbar();
        return;
      }

      // Keep same relative speed as 1 / (time + 5) but in ms
      percentTime += delta / ((time + 5) * 1000);
      $(".inProgress" + progressBarIndex).css({
        width: percentTime * 100 + "%"
      });

      if (percentTime >= 1) {
        $banner.slick("slickNext");
        progressBarIndex++;
        if (progressBarIndex > indexCount) {
          progressBarIndex = 0;
        }
        startProgressbar();
        return;
      }

      tick = window.requestAnimationFrame(rafInterval);
    }

    startProgressbar();

    // Click on bar to jump
    $(".progressBarContainer .item").on("click", function () {
      if (tick) {
        window.cancelAnimationFrame(tick);
        tick = null;
      }
      var goToIndex = $(this).find("span").data("slickIndex");
      if (typeof goToIndex !== "undefined") {
        $banner.slick("slickGoTo", goToIndex, false);
        progressBarIndex = goToIndex;
        startProgressbar();
      }
    });
  }

  /* --------------------------------------------------------------------------
   *  Quantity buttons (delegated)
   * -------------------------------------------------------------------------- */

  function initQtyButtons() {
    $(".g_prod_qty").on("click", ".flex .qty__adjust", function () {
      var $wrapper = $(this).closest(".g_prod_qty");
      var $input = $wrapper.find("input");
      var value = parseFloat($input.val()) || 0;

      if ($(this).hasClass("qty__adjust--plus")) {
        value += 1;
      } else {
        value = Math.max(1, value - 1);
      }

      $input.val(value);
    });
  }

  /* --------------------------------------------------------------------------
   *  Loox reviews + ScrollTrigger height watcher
   * -------------------------------------------------------------------------- */

  function initLooxScrollTriggerFix() {
    if (!window.ScrollTrigger) return;

    var looxContainer = document.getElementById("looxReviews");
    if (!looxContainer) return;

    function start() {
      var heightWatcherStarted = false;

      function startHeightWatcher(frame) {
        if (!frame || heightWatcherStarted) return;
        heightWatcherStarted = true;

        // Prefer ResizeObserver
        if (window.ResizeObserver) {
          var ro = new ResizeObserver(function () {
            if (window.ScrollTrigger) {
              ScrollTrigger.refresh();
            }
          });
          ro.observe(frame);
          return;
        }

        var lastHeight = frame.offsetHeight;
        var intervalId = window.setInterval(function () {
          if (!document.body.contains(frame)) {
            window.clearInterval(intervalId);
            return;
          }
          var currentHeight = frame.offsetHeight;
          if (currentHeight !== lastHeight && window.ScrollTrigger) {
            lastHeight = currentHeight;
            ScrollTrigger.refresh();
          }
        }, 1500); // a bit less frequent to save CPU
      }

      var observer = new MutationObserver(function () {
        var frame = document.getElementById("looxReviewsFrame");
        if (!frame) return;

        frame.addEventListener("load", function () {
          setTimeout(function () {
            if (window.ScrollTrigger) {
              ScrollTrigger.refresh();
            }
            startHeightWatcher(frame);
          }, 200);
        });

        startHeightWatcher(frame);
        observer.disconnect();
      });

      observer.observe(looxContainer, { childList: true, subtree: true });

      // Extra safety: delayed refreshes
      [800, 2000, 4000, 8000].forEach(function (delay) {
        setTimeout(function () {
          if (window.ScrollTrigger) {
            ScrollTrigger.refresh();
          }
        }, delay);
      });
    }

    // Only start when reviews enter the viewport
    if ("IntersectionObserver" in window) {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !started) {
            started = true;
            io.disconnect();
            start();
          }
        });
      });
      io.observe(looxContainer);
    } else {
      // Fallback: start immediately
      start();
    }
  }

  /* --------------------------------------------------------------------------
   *  Remove loop from videos inside .no-loop
   * -------------------------------------------------------------------------- */

  function initNoLoopHeroVideo() {
    var videos = document.querySelectorAll(".no-loop .hero__video");
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.removeAttribute("loop");
    });
  }

  /* --------------------------------------------------------------------------
   *  DOMContentLoaded: run all inits
   * -------------------------------------------------------------------------- */

  function lazyInitSection(selector, initFn, options) {
    var el = document.querySelector(selector);
    if (!el || typeof initFn !== "function") return;

    var initialized = false;

    function run() {
      if (initialized) return;
      initialized = true;
      initFn();
    }

    // If IntersectionObserver exists, init when section enters viewport.
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              run();
              observer.disconnect();
            }
          });
        },
        Object.assign(
          {
            rootMargin: "1000px 0px 1000px 0px"
          },
          options || {}
        )
      );

      observer.observe(el);
    } else {
      // Fallback for older browsers: init immediately.
      run();
    }
  }

  function initLightFeatures() {
    initVideoSlider();
    initCaseSlider();
    initWatchSlides();
    initBannerSliderProgress();
    initQtyButtons();
    initNoLoopHeroVideo();
  }

  function initHeavyFeatures() {
    // GSAP and ScrollTrigger must exist, otherwise nothing to do.
    if (!window.gsap || !window.ScrollTrigger) return;

    // Sticky cards section (Invisible engineering marvel)
    lazyInitSection(".service-section-wrap", initStickyCards);

    // Scroll-controlled video section
    lazyInitSection(".free_wrist", initScrollVideoSection);

    // Loox reviews ScrollTrigger fix
    lazyInitSection("#looxReviews", initLooxScrollTriggerFix);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLightFeatures();

    if ("requestIdleCallback" in window) {
      requestIdleCallback(initHeavyFeatures);
    } else {
      setTimeout(initHeavyFeatures, 0);
    }
  });
})(jQuery);


/* --------------------------------------------------------------------------
 *  AOS, country popup, and Magnific inline links
 * -------------------------------------------------------------------------- */

(function ($) {
  "use strict";

  // AOS after full load
  if (window.AOS && typeof AOS.init === "function") {
    window.addEventListener("load", function () {
      AOS.init();
    });
  }

  // Country selector popup (delayed, and only if popup exists)
  $(window).on("load", function () {
    if (!$("#countryPopup").length) return;
    if (typeof $.magnificPopup === "undefined") return;

    setTimeout(function () {
      $.getJSON("https://ipv4.json.wtfismyip.com/")
        .done(function (data) {
          if (data && data.YourFuckingCountry) {
            $(".loca").html(data.YourFuckingCountry);
          }

          if (data && data.YourFuckingCountryCode === "LB") {
            return;
          }

          $.magnificPopup.open({
            items: { src: "#countryPopup" },
            type: "inline",
            fixedContentPos: true
          });
        })
        .fail(function () {
          console.warn("Could not fetch IP info.");
        });
    }, 2000);
  });

  // Inline popups and close on International click
  $(function () {
    if (typeof $.magnificPopup === "undefined") return;

    $(".open-link").magnificPopup({
      type: "inline",
      fixedContentPos: true,
      midClick: true
    });

    $(document).on("click", '[data-country="International"]', function () {
      $(".mfp-close").trigger("click");
    });
  });
})(jQuery);
